
















































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import SerahTerimaDarahDialog from "@/components/bank-darah/SerahTerimaDarahDialog.vue";
import OrderBankDarahSvc from "@/services/OrderBankDarah";
import { appModule } from "@/store/modules/app";
import {
  OrderBankDarahRow,
  OrderSumber,
  RekapSerahTerimaRow,
  STATUS_WARNA
} from "@/types/order_bank_darah";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";
import { cocokCariPasien } from "@/utils/cariPasienBankDarah";

type PilihanOrder = {
  sumber: OrderSumber;
  id: number;
  persetujuan_kurang: string[];
};

@Component({ components: { VCDateTimePicker, SerahTerimaDarahDialog } })
export default class SerahTerimaSampelDarahPage extends Vue {
  filter: { tgl_start: string; tgl_end: string; term: string | null; final: "" | "ya" | "tidak" } = {
    tgl_start: moment().subtract(7, "days").format("YYYY-MM-DD"),
    tgl_end: moment().format("YYYY-MM-DD"),
    term: null,
    final: ""
  };

  rows: RekapSerahTerimaRow[] = [];
  loading = false;
  dialogPilih = false;
  memuatOrder = false;
  orderList: (OrderBankDarahRow & { key: string })[] = [];
  cariOrder: string | null = null;
  pilih: PilihanOrder | null = null;
  dialogSerahTerima = false;
  dialogHapus = false;
  hapusItem: RekapSerahTerimaRow | null = null;
  deleting = false;

  readonly finalItems = [
    { text: "Semua", value: "" },
    { text: "Diterima", value: "ya" },
    { text: "Draft", value: "tidak" }
  ];

  readonly headers = [
    { text: "Diterima", value: "diterima_at", width: "120px" },
    { text: "No Order / Jenis", value: "nomor", width: "190px" },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Ruang", value: "unit", sortable: false },
    { text: "Status", value: "final", sortable: false, width: "90px" },
    { text: "Mengetahui", value: "mengetahui", sortable: false },
    { text: "Aksi", value: "aksi", sortable: false, align: "end", width: "80px" }
  ];

  readonly headersOrder = [
    { text: "No Order", value: "nomor" },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Status", value: "status", sortable: false },
    { text: "", value: "aksi", sortable: false, align: "end" }
  ];

  get tglStartDate(): Date | null {
    return composeDate(this.filter.tgl_start);
  }
  set tglStartDate(val: Date | null) {
    this.filter.tgl_start = toDateString(val) || this.filter.tgl_start;
  }

  get tglEndDate(): Date | null {
    return composeDate(this.filter.tgl_end);
  }
  set tglEndDate(val: Date | null) {
    this.filter.tgl_end = toDateString(val) || this.filter.tgl_end;
  }

  get orderTampil() {
    return this.orderList.filter(o =>
      cocokCariPasien(this.cariOrder, [o.pasien_rm, o.pasien_nama, o.register_id, o.nomor])
    );
  }

  mounted() {
    this.muat();
  }

  warnaStatus(status: string): string {
    return STATUS_WARNA[status] || "blue-grey";
  }

  waktu(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  async muat() {
    this.loading = true;
    try {
      const res = await OrderBankDarahSvc.daftarSerahTerima(this.filter);
      this.rows = res.rows;
    } catch {
      this.rows = [];
    } finally {
      this.loading = false;
    }
  }

  async bukaPilihOrder() {
    this.dialogPilih = true;
    this.cariOrder = null;
    this.memuatOrder = true;
    try {
      const res = await OrderBankDarahSvc.list({
        tgl_start: null,
        tgl_end: null,
        status: ["diterima", "menunggu_sampel"]
      });
      this.orderList = res.rows
        .filter(r => !r.serah_terima || !r.serah_terima.is_locked)
        .map(r => ({ ...r, key: `${r.sumber}:${r.id}` }));
    } catch {
      this.orderList = [];
    } finally {
      this.memuatOrder = false;
    }
  }

  pilihOrder(o: OrderBankDarahRow) {
    this.dialogPilih = false;
    this.pilih = { sumber: o.sumber, id: o.id, persetujuan_kurang: o.persetujuan_kurang };
    this.dialogSerahTerima = true;
  }

  buka(sumber: OrderSumber, id: number) {
    this.pilih = { sumber, id, persetujuan_kurang: [] };
    this.dialogSerahTerima = true;
  }

  konfirmHapus(item: RekapSerahTerimaRow) {
    this.hapusItem = item;
    this.dialogHapus = true;
  }

  async hapus() {
    if (!this.hapusItem || this.deleting) return;
    this.deleting = true;
    try {
      const res = await OrderBankDarahSvc.hapusSerahTerima(
        this.hapusItem.sumber,
        this.hapusItem.permintaan_id
      );
      appModule.sendSuccessNotice(res.message);
      this.dialogHapus = false;
      this.hapusItem = null;
      this.muat();
    } catch {
      return;
    } finally {
      this.deleting = false;
    }
  }
}
